import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  getListings = async () => {
    try {
      const {body} = await Api.post('/listing/list')
      return body && !body.errors && Array.isArray(body.listings) ? body.listings : []
    } catch (e) {
      return []
    }
  }
}
